import { createAsyncThunk } from "@reduxjs/toolkit";
import { initiatePayment as initiatePaymentService } from "./payment.service";
import {
  InitiatePaymentRequest,
  InitiatePaymentResponse,
} from "./payment.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const initiatePayment = createAsyncThunk<
  InitiatePaymentResponse,
  InitiatePaymentRequest,
  { rejectValue: string }
>("payment/initiatePayment", async (data, { rejectWithValue }) => {
  try {
    const response = await initiatePaymentService(data);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});